interface HyperPayInlineLoaderProps {
  message: string;
}

/** Spinner + caption for boot and widget overlay states */
const HyperPayInlineLoader = ({ message }: HyperPayInlineLoaderProps) => (
  <div className="ac-hyperpay-inline-loader">
    <div className="ac-hyperpay-inline-loader__ring" aria-hidden />
    <p className="ac-hyperpay-inline-loader__message">{message}</p>
  </div>
);

export default HyperPayInlineLoader;
